import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '@/features/auth/hooks/useAuth';
import { routes } from '@/routes/routes';
import { PageLoader } from '@/layouts/components/PageLoader/PageLoader';
import { useFreshchat } from '@/features/support';
import { useLogger } from '@/lib/logger';

function LogoutPage() {
  const navigate = useNavigate();
  const logger = useLogger();
  const { stop } = useFreshchat();
  const { logout } = useAuth();

  useEffect(() => {
    const handleLogout = async () => {
      try {
        await logout();
        await stop();
      } catch (error) {
        logger.error('Logout failed', {
          error: error instanceof Error ? error.message : String(error),
        });
      }

      navigate(routes.public.signup, { replace: true });
    };

    handleLogout();
  }, []);

  return <PageLoader />;
}

export default LogoutPage;
